import { render, staticRenderFns } from "./DetailsChallengeModal.vue?vue&type=template&id=27fdb889&scoped=true&"
import script from "./DetailsChallengeModal.vue?vue&type=script&lang=js&"
export * from "./DetailsChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailsChallengeModal.vue?vue&type=style&index=0&id=27fdb889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fdb889",
  null
  
)

export default component.exports